import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { fetchFileUrl } from './financeApi';

export const FileViewer = ({ file, token, onClose }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!file) return undefined;
    let url;
    setData(null);
    fetchFileUrl(token, file.kind, file.id)
      .then((d) => { url = d.url; setData(d); })
      .catch(() => toast.error('Could not open the file'));
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [file, token]);

  return (
    <Dialog open={!!file} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-2xl" data-testid="file-viewer-dialog">
        <DialogHeader><DialogTitle>{file?.title}</DialogTitle></DialogHeader>
        {!data && <p className="text-sm text-muted-foreground">Loading…</p>}
        {data && data.type === 'application/pdf' && <iframe title="Proof" src={data.url} className="w-full h-[70vh] rounded-lg border" data-testid="file-viewer-pdf" />}
        {data && data.type !== 'application/pdf' && <img src={data.url} alt={file?.title} className="w-full max-h-[70vh] object-contain rounded-lg border" data-testid="file-viewer-image" />}
      </DialogContent>
    </Dialog>
  );
};
